let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bSjyK"), load("hlJc4"), load("j6IGj"), load("5a6vI")]).then(() => parcelRequire('alf8C'));